import { openBlock, createElementBlock, createStaticVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "uikit-cave-icon"
};
const _hoisted_1 = {
  width: "20",
  height: "16",
  viewBox: "0 0 20 16",
  fill: "currentColor",
  stroke: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g clip-path="url(#clip0_3235_2411)"><path opacity="0.4" d="M19.0781 3.65625L10.5742 0.113281C10.3906 0.046875 10.1953 0.0078125 10 0C9.80078 0.0078125 9.60547 0.0429688 9.42188 0.113281L0.921875 3.65625C0.363281 3.89062 0 4.43359 0 5.03906V15.5C0 15.7773 0.222656 16 0.5 16H2.5C2.77734 16 3 15.7773 3 15.5V7C3 6.44922 3.45703 6 4.01953 6H15.9805C16.543 6 17 6.44922 17 7V15.5C17 15.7773 17.2227 16 17.5 16H19.5C19.7773 16 20 15.7773 20 15.5V5.03906C20 4.43359 19.6367 3.89062 19.0781 3.65625Z"></path><path d="M4 16H16V11H4.00391L4 16ZM8.5 13H11.5C11.7773 13 12 13.2227 12 13.5C12 13.7773 11.7773 14 11.5 14H8.5C8.22266 14 8 13.7773 8 13.5C8 13.2227 8.22266 13 8.5 13ZM4 10H15.9844L16 7H4V10Z"></path></g><defs><clipPath id="clip0_3235_2411"><rect width="20" height="16" fill="white"></rect></clipPath></defs>', 2);
const _hoisted_4 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
const uikitCave = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  uikitCave as default
};
//# sourceMappingURL=uikit-cave.vue.es.js.map
